import React from "react";
import PropTypes from "prop-types";

const MembershipSubtotal = props => {
  return (
    <li
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "15px 10px",
        borderBottom: "1px solid #dedede"
      }}
    >
      <p
        style={{
          marginBottom: 0,
          fontFamily: "Open Sans, sans-serif",
          fontWeight: 600
        }}
      >
        Subtotal
      </p>
      <span style={{ fontWeight: "bold" }}>
        $
        {parseFloat(
          parseFloat(
            JSON.parse(props.program.prices[props.selected]).price_per_term
          )
        ).toFixed(2)}
      </span>
    </li>
  );
};

MembershipSubtotal.propTypes = {
  program: PropTypes.shape({
    prices: PropTypes.array.isRequired
  }).isRequired,
  selected: PropTypes.number.isRequired
};

export default MembershipSubtotal;
